module.exports = __webpack_public_path__ + "img/wu-big1.8e355602.svg";